import {Card} from "../components/pages/Checkout/PaymentMethods";
import {faCreditCard, IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {faCcAmex, faCcMastercard, faCcVisa} from "@fortawesome/free-brands-svg-icons";

export const getBrandIcon = (card: Card): IconDefinition => {
    if (card.brand === "visa") return faCcVisa
    if (card.brand === "mastercard") return faCcMastercard
    if (card.brand === "amex") return faCcAmex
    return faCreditCard
}